<template>
  <SignatureDialogLayout title="Pix">
    <template v-if="!paymentCode?.encodedImage">
      <div class="pix">
        <img src="@/assets/pix-logotipo.png" alt="pix" class="mb-6" height="72px" />

        <h3>Pagamento por Pix</h3>
        <p>A confirmação de pagamento é feita em alguns segundos. Após a confirmação você receberá um e-mail com informações da sua assinatura</p>
      </div>

      <SignatureSafePaymentSection />
    </template>

    <template v-else>
      <div class="pix">
        <h3>Seu QR Code para pagamento</h3>
        <div class="qrcode">
          <img :src="'data:image/png;base64,' + paymentCode.encodedImage" />
        </div>
        <p>Para usar o ”Pix Copia e Cola” copie o código abaixo e cole na área de Pix do seu banco.</p>

        <div class="code-options">
          <div class="data">{{ paymentCode?.payload }}</div>
          <VBtn color="primary" depressed style="width: 100%" @click="copyToClipboard">Copiar Pix copia e cola</VBtn>
        </div>
      </div>

      <VSnackbar v-model="snackbar.isOpen" :color="snackbar.error ? 'error' : 'primary accent-4'" :timeout="1500" absolute shaped bottom>
        {{ snackbar.text }}
      </VSnackbar>
    </template>

    <template #footer>
      <SignatureResume v-if="!paymentCode?.encodedImage" :show-details="false">
        <template #checkTerm>
          <div style="display: flex; align-items: center; background-color: #fff; border-radius: 6px; padding: 6px; margin-bottom: 15px">
            <v-checkbox v-model="acceptTerm" hide-details style="padding: 0 10px;"> </v-checkbox>
            <div style="font-size: 13px">
              <span>Li e aceito os <span style="font-weight: 600" @click="openMembershipTerms">Termos de adesão</span> e </span>
              <span style="font-weight: 600" @click="openTerms">Termos de uso e privacidade.</span>
            </div>
          </div>
        </template>

        <template #actions>
          <VBtn depressed @click="$emit('back')">Voltar</VBtn>
          <VBtn color="primary" :disabled="!acceptTerm" depressed @click="$emit('save')">Finalizar</VBtn>
        </template>
      </SignatureResume>

      <template v-else>
        <VBtn depressed @click="$emit('finish')">Ir para faturas</VBtn>
      </template>
    </template>
  </SignatureDialogLayout>
</template>

<script>
import { mapState } from 'vuex';

import SignatureDialogLayout from '../SignatureDialogLayout';
import SignatureResume from '../SignatureResume';
import SignatureSafePaymentSection from '../SignatureSafePaymentSection';

export default {
  name: 'BoletoPayment',
  components: { SignatureDialogLayout, SignatureResume, SignatureSafePaymentSection },

  data() {
    return {
      code: null,
      snackbar: {
        isOpen: false,
        text: ''
      },
      acceptTerm: false
    };
  },
  computed: {
    ...mapState('Payment', ['paymentCode'])
  },
  methods: {
    async copyToClipboard() {
      try {
        await navigator.clipboard.writeText(this.paymentCode?.payload);
        this.snackbar = {
          isOpen: true,
          error: false,
          text: 'Copiado com sucesso'
        };
      } catch {
        this.snackbar = {
          isOpen: true,
          error: true,
          text: 'Erro ao copiar código'
        };
      }
    },
    openTerms() {
      this.$store.dispatch('Auth/openTerms');
    },
    openMembershipTerms() {
      this.$store.dispatch('Auth/openMembershipTerms');
    }
  }
};
</script>
<style lang="scss" scoped>
.v-input--selection-controls {
  margin-top: 0px !important;
  padding-top: 0px !important;
}

.pix {
  text-align: center;
  padding: 35px 0;

  h3 {
    color: #3f505f;
    font-size: 16px;
    font-weight: 600;
    margin-bottom: 4px;
  }

  p {
    color: #6e7481;
    font-size: 12px;
    text-align: center;
  }

  .code-options {
    .data {
      color: #6e7481;
      font-size: 16px;
      font-weight: 400;
      word-break: break-all;
      text-align: left;

      border-radius: 6px;
      border: 1px solid #d5d7dd;
      padding: 8px 12px;
      width: 100%;
      margin-bottom: 12px;
    }
  }

  .qrcode {
    img {
      width: 250px;
      height: 250px;
    }
  }
}
</style>
